import { render, staticRenderFns } from "./AddrNav.vue?vue&type=template&id=62b40e5a&lang=pug&"
import script from "./AddrNav.vue?vue&type=script&lang=js&"
export * from "./AddrNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports